<template>
  <v-dialog v-model="active" width="600">
    <template v-slot:activator="{ on }">
      <v-list-item v-on="on">
        <v-list-item-title style="white-space:normal">Math Placement Test</v-list-item-title>
      </v-list-item>
    </template>
    <v-card>
      <v-toolbar>
        <v-toolbar-title>Math Placement Test</v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="active = false">
          <v-icon>fal fa-times</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text style="margin-top:2em">
        <p>There are two versions of the Math Placement Test. One is for those who have taken a pre-calculus or trigonometry course and one is for those who have not. Please choose your option below so you can be taken to the correct placement test.</p>
        <radio v-model="test" :items="tests" label="Placement Test" outlined hide-details>
          <template v-slot:item="{ item, on, attr }">
            <v-list-item v-on="on" v-bind="attr" :disabled="item.disabled">
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
                <v-list-item-subtitle v-if="item.subtext">{{ item.subtext }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
        </radio>
        <template v-if="test">
          <h4>Logging In</h4>
          <p>This placement test is run through Canvas, our Learning Management System, and will open in a new window or tab. This uses our campus SSO (Single Sign-On) through Microsoft. To log in, enter your full Covenant email address for the username and then your password that you use for Scots Connect.</p>
          <h4>Important Test Information</h4>
          <ul class="mb-2">
            <li>The test has {{ test === 'standard' ? 2 : 3 }} sections</li>
            <li>You need to take {{ test === 'standard' ? 'both' : 'all three'}} sections back-to-back</li>
            <li>Estimated test time: {{ test === 'standard' ? 'less than 1 hour' : '1 - 1.5 hours' }}</li>
            <li>Maximum test time: {{ test === 'standard' ? '1.5' : '2.25' }} hours</li>
            <li>Make sure you have enough time to complete {{ test === 'standard' ? 'both' : 'all three' }} sections before starting!</li>
          </ul>
          <h4>When Completed</h4>
          <p>Upon completion of the test, you can close the Canvas window or tab and click "Test is Complete" to continue on with Scots Connect. The item will stay on your to-do list until the test scores are loaded from Canvas, which can take a few hours.</p>
        </template>
      </v-card-text>
      <v-card-actions>
        <v-btn v-if="testIsStarted" @click="done()">Test is Complete</v-btn>
        <v-btn v-else :disabled="test === ''" @click="openLink()">Start Test Now</v-btn>
        <v-spacer />
        <v-btn color="info" @click="dismiss()">Not Taking Test</v-btn>
        <v-spacer />
        <v-btn @click="active = false">Take Test Later</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { ref } from '@vue/composition-api'
export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {
          title: '',
          link: '',
          link2: '',
          dialogText: '',
          added: new Date(),
          viewed: null,
          clicked: null,
          done: false,
          dismissed: false,
          linkText: 'Take test now',
          dismissText: 'Already Taken or Not Taking'
        }
      }
    }
  },
  components: {
    Radio: () => import('../forms/inputs/Radio')
  },
  setup (props, { root }) {
    const active = ref(false)
    const test = ref('')
    const tests = ref([{ text: 'I have taken Pre-Calculus/Trigonometry', value: 'extended' }, { text: 'I have not taken Pre-Calculus/Trigonometry', value: 'standard' }])
    const testIsStarted = ref(false)

    async function dismiss () {
      // Find the item that matches the title
      const { _id, actions } = await root.$store.dispatch('getTracker')
      for (let i = 0; i < actions.length; i++) {
        if (actions[i].title === props.item.title) {
          root.$feathers.service('orientation/tracker').patch(_id, { ['actions.' + i + '.dismissed']: true }).then(({ actions }) => {
            active.value = false
            root.$store.commit('setActions', actions)
          })
          break
        }
      }
    }

    async function done () {
      active.value = false
    }

    async function openLink () {
      const { _id } = await root.$store.dispatch('getTracker')
      const link = test === 'extended' ? props.item.link2 : props.item.link
      // Store whether they're taking the extended or standard test
      root.$feathers.service('orientation/tracker').patch(_id, { 'actions.$[el].mathExtended': test === 'extended', arrayFilters: [{ 'el.title': props.item.title }] })
      window.open(link)
      testIsStarted.value = true
    }

    return {
      active,
      test,
      tests,
      testIsStarted,
      dismiss,
      done,
      openLink
    }
  }
}
</script>
